import { HttpClient } from '@angular/common/http';
import { AppConfig } from 'src/app/app.config';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../app.config";
var PlannerService = /** @class */ (function () {
    function PlannerService(http, config) {
        this.http = http;
        this.config = config;
        this.url = this.config.getConfig("apiEndpoint") + "/planner";
    }
    PlannerService.prototype.getUnassigned = function (date) {
        return this.http.get(this.url + "/unassigned/" + date);
    };
    PlannerService.prototype.getAssigned = function (type, date) {
        return this.http.get(this.url + "/assigned/" + type + "/" + date);
    };
    PlannerService.prototype.getCancelled = function (date) {
        return this.http.get(this.url + "/cancelled/" + date);
    };
    PlannerService.prototype.getDetail = function (id) {
        return this.http.get(this.url + "/" + id);
    };
    PlannerService.prototype.getAvailable = function (type, id) {
        return this.http.get(this.url + "/available/" + type + "/" + id);
    };
    PlannerService.prototype.saveService = function (body) {
        return this.http.put(this.url, body);
    };
    PlannerService.prototype.deleteService = function (id) {
        return this.http.delete(this.url + "/" + id);
    };
    PlannerService.ngInjectableDef = i0.defineInjectable({ factory: function PlannerService_Factory() { return new PlannerService(i0.inject(i1.HttpClient), i0.inject(i2.AppConfig)); }, token: PlannerService, providedIn: "root" });
    return PlannerService;
}());
export { PlannerService };
